import { AsyncJob } from "../../../models/async-job.model";
import { BaseFormInstanceOperation } from "./base-form-instance-operation"
import { FormInstanceSaveMetrics } from "../../../models/export-import/form-instance-save-metrics.model";
import { FormInstanceOperationsDialog } from "../form-instance-operations.dialog";
import { IFormDialogOperation } from "./i-form-dialog-operation";

export class SaveFormOperation extends BaseFormInstanceOperation implements IFormDialogOperation {

    public get title(): string {
        return "Save Form";
    }
    public performAutomatically: boolean = true;
    constructor(dialog: FormInstanceOperationsDialog) {
        super(dialog)
    }

    public performOperation(): void {
        this.dialog.asyncFormInstanceSaveService.updateContentAsync(this.dialog.initInfo.formInstance).then(asyncJob => {
            this.dialog.AsyncJob = asyncJob;
            this.dialog.startMonitoringJob(this.dialog.AsyncJob, this.saveFormJobCompletedCallback, this.saveFormJobCompletedCallback);
        });
    }

    public dismissDialog(): void {
        this.dialog.dialogRef.close({ reload: false });
    }

    public disableDismissButton(): boolean {
        return this.dialog.JobCompleted != true;
    }

    public get showStartOperationManuallyButton(): boolean {
        return false;
    };

    public get showDismissButton(): boolean {
        return true;
    }

    public get showGoToSiteHomePageButton(): boolean {
        return this.dialog.JobErrorOccurred != true;
    }

    public get showDismissWithReloadButton(): boolean {
        return false;
    }

    public get Status() {
        let status: string = null;

        if (!this.dialog.JobInProgress && this.dialog.AsyncJobInfo == null) {

            status = 'Save will start automatically...'
        } else if (this.dialog.JobInProgress) {
            status = 'Save in progress. Please wait...';
        } else if (!this.dialog.JobErrorOccurred) {
            status = 'Save completed successfully';
        } else if (this.dialog.JobErrorOccurred) {
            status = 'An error occurred';
        } else {
            status = 'An error occurred';
        }

        return status;
    }

    private saveFormJobCompletedCallback = (asyncJob: AsyncJob): void => {
        if (this.dialog.jobIsCompleted()) {
            let saveStatus: Object = JSON.parse(asyncJob.stdOut);
            this.dialog.SaveMetrics = new FormInstanceSaveMetrics(saveStatus);
            this.resetDirtyFormInstanceElements();
        } else if ((asyncJob.stdOut != null) && (asyncJob.stdOut.trim() != '')) {
            let saveStatus: Object = JSON.parse(asyncJob.stdOut);
            this.dialog.SaveMetrics = new FormInstanceSaveMetrics(saveStatus);
        } else if (asyncJob.status == 'Completed with error') {
            //this.resetDirtyFormInstanceElements();
        }
    }

    // We take care here of ensuring that FormInstanceElements get reset so that once the save is complete the user
    // won't get a "you have unsaved changes" warning when they navigate away. (This was formerly done within FormFiller.afterFormInstanceSave())
    private resetDirtyFormInstanceElements() {
        const elements = this.dialog.initInfo.dirtyElements;
        for (let el of elements) {
            el.resetOriginalValues();
        }
    }

}
